module.exports = __webpack_public_path__ + "static/media/misforsta.383a774e.m4a";